import { c as _c } from "react/compiler-runtime";
import { ExternalLink } from 'lucide-react';
import type { MergeDropdownCheckRun } from './types';
import { getCheckIcon } from '../../merge-dropdown-utils';
import { CheckAnnotations } from './check-annotations';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * Renders a single row representing a check run (icon, name, link, and a tooltip with details).
 *
 * @param {object} props
 * @param {CheckRun} props.checkRun - The check run to render.
 * @returns {JSX.Element} A row component showing the check name, status icon, and optional link to details.
 */
export function CheckRunRow(t0) {
  const $ = _c(18);
  const {
    checkRun
  } = t0;
  const hasAnnotations = Array.isArray(checkRun.annotations) && checkRun.annotations.length > 0;
  const hasOutput = Boolean(checkRun.output?.summary || checkRun.output?.text || hasAnnotations);
  let t1;
  if ($[0] !== checkRun.conclusion || $[1] !== checkRun.status) {
    t1 = getCheckIcon({
      status: checkRun.status,
      conclusion: checkRun.conclusion
    });
    $[0] = checkRun.conclusion;
    $[1] = checkRun.status;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== checkRun.name) {
    t2 = <span className="text-zinc-200">{checkRun.name}</span>;
    $[3] = checkRun.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== checkRun.html_url || $[6] !== checkRun.name) {
    t3 = checkRun.html_url && <a href={checkRun.html_url} target="_blank" rel="noopener noreferrer" className="text-muted-foreground opacity-0 hover:text-foreground group-hover:opacity-100" aria-label={`View ${checkRun.name} details`}><ExternalLink className="size-4" /></a>;
    $[5] = checkRun.html_url;
    $[6] = checkRun.name;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <TooltipTrigger asChild={true}><div className="cursor-pointer"><div className="group flex items-center justify-between"><div className="flex items-center gap-2 text-sm text-muted-foreground group-hover:text-foreground">{t1}{t2}{t3}</div></div></div></TooltipTrigger>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== checkRun || $[13] !== hasOutput) {
    t5 = hasOutput && <TooltipContent><CheckAnnotations checkRun={checkRun} /></TooltipContent>;
    $[12] = checkRun;
    $[13] = hasOutput;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <TooltipProvider><Tooltip delayDuration={0}>{t4}{t5}</Tooltip></TooltipProvider>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}